import { BY_LOCATION_SUFFIX } from '../constants';

export default function getSchemaFields({ laborUISchema }) {
  if (!laborUISchema) {
    return [];
  }

  const schemaFields = [];
  function gatherSchemaFields(item) {
    schemaFields.push({
      fieldName: item.property,
      formula: item.formula,
      calculateOnAggregated: item.calculateOnAggregated,
      calculateOnSalaries: item.calculateOnSalaries,
    });

    if (item.breakdownByLocation) {
      schemaFields.push({
        fieldName: `${item.property}${BY_LOCATION_SUFFIX}`,
        originalFieldName: item.property,
        breakdownByLocation: true,
        formula: item.formula,
        calculateOnAggregated: item.calculateOnAggregated,
        calculateOnSalaries: item.calculateOnSalaries,
      });
    }

    if (item.children) {
      item.children.items.forEach(gatherSchemaFields);
    }
  }

  laborUISchema.summary.items.forEach(gatherSchemaFields);
  return schemaFields;
}
